
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-amber-600" style={{ fontFamily: '"Pacifico", serif' }}>
                馬的咖啡故事館
              </h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
                >
                  首頁
                </button>
                <button 
                  onClick={() => scrollToSection('coffee')}
                  className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
                >
                  咖啡介紹
                </button>
                <button 
                  onClick={() => scrollToSection('story')}
                  className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
                >
                  我們的故事
                </button>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
                >
                  聯絡我們
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}